/*
* Project: LegalPlace assistant
* File: src/redux/actions/toggle_preview.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

const TOGGLE_PREVIEW = 'LP_TOGGLE_PREVIEW';
const SHOW_POPOVER = 'SHOW_POPOVER';
const HIDE_POPOVER = 'HIDE_POPOVER';


function togglePreview() {
  return {
    type: TOGGLE_PREVIEW,
  };
}

function showPopover() {
  return {
    type: SHOW_POPOVER,
  };
}

function hidePopover() {
  return {
    type: HIDE_POPOVER,
  };
}


export {
  TOGGLE_PREVIEW,
  SHOW_POPOVER,
  HIDE_POPOVER,
  togglePreview,
  showPopover,
  hidePopover,
};



// WEBPACK FOOTER //
// ./src/redux/actions/toggle_preview.js